import React from 'react'
import { useParams } from 'react-router-dom';
import RequireAuth from '../../components/auth/RequireAuth';
import { useAuthenticator } from '@aws-amplify/ui-react';

const RegistrationForm = () => {
    const { seriesId } = useParams();

    return (
        <div>
            {seriesId} Series Registration
        </div>
    )
}


const Register = () => {
    const { seriesId } = useParams();
    const { route } = useAuthenticator(context => [context.route]);

    return seriesId === 'second' 
        ? <RegistrationForm />
        : <RequireAuth allowedRoles={['FrgUsers']}><RegistrationForm /></RequireAuth>
}

export default Register;

